import BottomSheet from 'components/UI/Responsive/BottomSheet';
import DetailList from 'components/UI/Responsive/DetailList';
import SidePanel from 'components/UI/Responsive/SidePanel';
import { Order } from 'model/Order';
import { buildMyOrderDetailGroups } from './buildMyOrderDetailGroups';

import * as S from './styles';

interface Props {
  order: Order | null;
  onClose: () => void;
}

const describeTitle = (order: Order) =>
  `${order.productCode} – ${order.description}`;

export function MyOrderDetailPanel({ order, onClose }: Props) {
  if (!order) return null;

  return (
    <SidePanel isOpen onClose={onClose} title={describeTitle(order)}>
      <DetailList groups={buildMyOrderDetailGroups(order)} />
    </SidePanel>
  );
}

export function MyOrderDetailSheet({ order, onClose }: Props) {
  if (!order) return null;

  return (
    <BottomSheet isOpen onClose={onClose} title={describeTitle(order)}>
      <S.SheetDetail>
        <DetailList groups={buildMyOrderDetailGroups(order)} />
      </S.SheetDetail>
    </BottomSheet>
  );
}
